(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('header-drawer[data-sa-compact-drawer] a');
    if (!link) return;
    const drawer = link.closest('header-drawer');
    const toggle = drawer.querySelector('summary');
    if (typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(event, toggle);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-axis-support"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('axis-comfort')) {
  customElements.define('axis-comfort', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) {
        this.motionPreference?.addEventListener?.('change', this.onMotionChange);
        this.select(this.active || 0);
        return;
      }
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.spots = Array.from(this.querySelectorAll('[data-spot]'));
      this.focusMarker = this.querySelector('[data-focus]');
      this.heightGuide = this.querySelector('[data-height-guide]');
      this.upperGuide = this.querySelector('[data-upper-guide]');
      this.motionTimers = [];
      this.motionPreference = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : {matches:false};
      this.onMotionChange = () => this.select(this.active || 0);
      this.motionPreference.addEventListener?.('change', this.onMotionChange);
      if (!this.tabs.length) return;

      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-tab]');
        if (tab) this.select(Number(tab.dataset.tab));
      });
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-tab]');
        if (!tab) return;
        let index = Number(tab.dataset.tab);
        if (event.key === 'ArrowDown') index = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowUp') index = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.select(index, true);
      });
      this.dataset.ready = 'true';
      this.select(0);
    }
    disconnectedCallback() {
      this.clearMotion();
      this.motionPreference?.removeEventListener?.('change', this.onMotionChange);
    }
    clearMotion() {
      (this.motionTimers || []).forEach(timer => window.clearTimeout(timer));
      this.motionTimers = [];
    }
    later(callback, delay) {
      this.motionTimers.push(window.setTimeout(callback, delay));
    }
    moveHighlight(index) {
      this.clearMotion();
      const target = this.spots[index];
      if (!target || !this.focusMarker) return;
      const zones = [
        {name:'neck',width:'24%',height:'12%'},
        {name:'shoulders',width:'12%',height:'28%'},
        {name:'head',width:'18%',height:'25.2%'},
        {name:'heights',width:'24%',height:'12%'}
      ];
      const zone = zones[index] || zones[0];
      const x = target.style.getPropertyValue('--spot-x').trim();
      const y = target.style.getPropertyValue('--spot-y').trim();
      const marker = this.focusMarker;
      marker.dataset.zone = zone.name;
      marker.dataset.motion = '';
      marker.style.left = x;
      marker.style.top = y;
      marker.style.width = zone.width;
      marker.style.height = zone.height;
      this.heightGuide.removeAttribute('data-visible');
      this.upperGuide.removeAttribute('data-visible');
      if (index === 3) {
        const lower = this.spots[0];
        const lowerX = lower.style.getPropertyValue('--spot-x').trim();
        const lowerY = lower.style.getPropertyValue('--spot-y').trim();
        this.heightGuide.style.left = lowerX;
        this.heightGuide.style.top = lowerY;
        this.heightGuide.setAttribute('data-visible', '');
        this.upperGuide.style.left = x;
        this.upperGuide.style.top = y;
        this.upperGuide.setAttribute('data-visible', '');
        if (!this.motionPreference.matches) {
          this.later(() => {
            marker.style.left = lowerX;
            marker.style.top = lowerY;
          }, 1400);
          this.later(() => {
            marker.style.left = x;
            marker.style.top = y;
          }, 3400);
        }
      } else if (!this.motionPreference.matches) {
        this.later(() => marker.dataset.motion = zone.name, 740);
      }
    }
    select(index, focus = false) {
      this.active = index;
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-expanded', String(i === index)); });
      this.panels.forEach((panel, i) => panel.hidden = i !== index);
      this.moveHighlight(index);
      if (focus) this.tabs[index].focus({preventScroll:true});
    }
  });
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[data-comfort-item]');
    const section = panel && panel.closest('axis-comfort');
    if (section && section.dataset.ready) section.select(Number(panel.dataset.comfortItem));
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-cloud-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sa-cloud-reviews')) {
  class SACloudReviews extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      this.originals = [...this.querySelectorAll('[data-review]')];
      this.count = this.originals.length;
      if (!this.count) return;
      this.loop = this.count >= 5;
      this.base = this.loop ? this.count : 0;
      this.selected = this.count >= 3 ? 1 : 0;
      this.visual = this.base + this.selected;
      this.duration = Number(this.dataset.duration) || 700;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.locked = false;
      this.pending = null;
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      if (this.loop) {
        const clone = (card) => {
          const copy = card.cloneNode(true);
          copy.dataset.clone = 'true';
          copy.removeAttribute('data-shopify-editor-block');
          copy.setAttribute('aria-hidden', 'true');
          copy.inert = true;
          copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
          return copy;
        };
        this.track.prepend(...this.originals.map(clone));
        this.track.append(...this.originals.map(clone));
      }
      this.cards = [...this.track.children];
      const listen = (el, type, fn) => el?.addEventListener(type, fn, { signal: this.abort.signal });
      listen(this.previous, 'click', () => this.step(-1));
      listen(this.next, 'click', () => this.step(1));
      this.dots.forEach((dot, i) => listen(dot, 'click', () => this.goTo(i)));
      listen(this, 'keydown', event => {
        if (event.target.closest('input, textarea, select')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.step(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      listen(this.viewport, 'pointerdown', event => this.pointerDown(event));
      listen(this.viewport, 'pointermove', event => this.pointerMove(event));
      listen(this.viewport, 'pointerup', event => this.pointerEnd(event));
      listen(this.viewport, 'pointercancel', () => this.cancelDrag());
      listen(this.viewport, 'lostpointercapture', () => this.cancelDrag());
      listen(this.viewport, 'dragstart', event => event.preventDefault());
      listen(this.viewport, 'wheel', event => {
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY) || Math.abs(event.deltaX) < 6) return;
        event.preventDefault();
        const now = performance.now();
        if (now - (this.wheelAt || -1000) > this.duration + 100) {
          this.wheelAt = now;
          this.step(event.deltaX > 0 ? 1 : -1);
        }
      });
      listen(this, 'shopify:block:select', event => {
        const index = this.originals.findIndex(card => card.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.goTo(index, true);
      });
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.viewport);
      this.setAttribute('data-ready', '');
      this.measure();
    }
    measure() {
      if (!this.isConnected || !this.count) return;
      const width = this.viewport.clientWidth;
      if (!width) return;
      this.gap = parseFloat(getComputedStyle(this).getPropertyValue('--sa-cr-gap')) || 24;
      const visible = width >= 990 ? 3.8 : width >= 750 ? 2.5 : 1.16;
      this.visibleCount = width >= 990 ? 3 : width >= 750 ? 2 : 1;
      this.fits = this.count <= this.visibleCount;
      this.cardWidth = this.fits
        ? Math.min(410, (width - 32 - this.gap * (this.count - 1)) / this.count)
        : (width - this.gap * (visible - 1)) / visible;
      this.style.setProperty('--sa-cr-card-width', `${Math.max(180, this.cardWidth)}px`);
      this.cardWidth = Math.max(180, this.cardWidth);
      this.viewportWidth = width;
      this.stride = this.cardWidth + this.gap;
      this.querySelector('[data-controls]')?.toggleAttribute('hidden', this.fits);
      this.finish(false);
    }
    offset() {
      if (this.fits) return (this.viewportWidth - (this.count * this.cardWidth + (this.count - 1) * this.gap)) / 2;
      return (this.viewportWidth - this.cardWidth) / 2 - this.visual * this.stride;
    }
    paint() {
      this.track.style.transform = `translate3d(${this.offset()}px,0,0)`;
      const lift = this.reduceMotion.matches ? 0 : Number(this.dataset.lift) || 0;
      this.cards.forEach((card, index) => {
        const distance = Math.abs(index - this.visual);
        const central = this.fits || distance <= (this.visibleCount === 1 ? 0 : 1);
        card.style.setProperty('--sa-cr-lift', !this.fits && distance === 0 ? `${-lift}px` : '0px');
        card.style.setProperty('--sa-cr-scale', central ? '1' : '.95');
        card.style.setProperty('--sa-cr-opacity', central ? '1' : '.5');
        if (!card.dataset.clone) {
          card.inert = !central;
          card.setAttribute('aria-hidden', central ? 'false' : 'true');
        }
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.selected ? 'true' : 'false'));
      if (this.previous) this.previous.disabled = !this.loop && this.selected === 0;
      if (this.next) this.next.disabled = !this.loop && this.selected === this.count - 1;
      if (this.dataset.cloudMotion === 'true' && !this.reduceMotion.matches) {
        this.style.setProperty('--sa-cr-cloud-shift', `${this.selected % 2 ? 12 : -12}px`);
      } else this.style.setProperty('--sa-cr-cloud-shift', '0px');
    }
    step(direction) {
      if (this.fits) return;
      if (this.locked) { this.pending = direction; return; }
      const next = this.selected + direction;
      if (!this.loop && (next < 0 || next >= this.count)) return;
      this.selected = ((next % this.count) + this.count) % this.count;
      this.visual += direction;
      this.animate();
    }
    goTo(index, instant = false) {
      if (index < 0 || index >= this.count) return;
      clearTimeout(this.timer);
      this.pending = null;
      this.selected = index;
      this.visual = this.base + index;
      if (instant || this.fits) this.finish();
      else this.animate();
    }
    animate() {
      this.removeAttribute('data-instant');
      this.locked = true;
      this.paint();
      clearTimeout(this.timer);
      if (this.reduceMotion.matches) this.finish();
      else this.timer = setTimeout(() => this.finish(), this.duration + 30);
    }
    finish(announce = true) {
      clearTimeout(this.timer);
      this.setAttribute('data-instant', '');
      this.visual = this.base + this.selected;
      this.paint();
      void this.track.offsetWidth;
      this.removeAttribute('data-instant');
      this.locked = false;
      if (announce) {
        const text = (this.dataset.currentLabel || '').replace('{current}', String(this.selected + 1)).replace('{total}', String(this.count));
        this.querySelector('[data-status]').textContent = text;
      }
      if (this.pending !== null) {
        const direction = this.pending;
        this.pending = null;
        this.step(direction);
      }
    }
    pointerDown(event) {
      if (this.locked || this.fits || event.button !== 0 || event.target.closest('a, button')) return;
      this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, dragging: false };
    }
    pointerMove(event) {
      const p = this.pointer;
      if (!p || p.id !== event.pointerId) return;
      const dx = event.clientX - p.x;
      const dy = event.clientY - p.y;
      if (!p.dragging && Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) { this.pointer = null; return; }
      if (!p.dragging && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
        p.dragging = true;
        this.setAttribute('data-dragging', '');
        this.viewport.setPointerCapture(event.pointerId);
      }
      if (!p.dragging) return;
      p.dx = Math.max(-this.stride, Math.min(this.stride, dx));
      this.track.style.transform = `translate3d(${this.offset() + p.dx}px,0,0)`;
    }
    pointerEnd(event) {
      const p = this.pointer;
      if (!p || p.id !== event.pointerId) return;
      this.pointer = null;
      this.removeAttribute('data-dragging');
      if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
      if (p.dragging && Math.abs(p.dx) > 40) {
        this.step(p.dx < 0 ? 1 : -1);
        this.paint();
      } else this.paint();
    }
    cancelDrag() {
      if (!this.pointer) return;
      this.pointer = null;
      this.removeAttribute('data-dragging');
      this.paint();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
      this.querySelectorAll('[data-clone]').forEach(card => card.remove());
      this.ready = false;
      this.removeAttribute('data-ready');
    }
  }
  customElements.define('sa-cloud-reviews', SACloudReviews);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-grand-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const anchors = {'sleep-anatomy-design':'.sa-anatomy','sleep-anatomy-quiz':'.saf','sleep-anatomy-journal':'.sa-journal'};
  const attachAnchors = () => {
    Object.entries(anchors).forEach(([id, selector]) => {
      const target = document.querySelector(selector);
      if (target && !document.getElementById(id)) {
        const anchor = document.createElement('span');
        anchor.id = id;
        anchor.style.display = 'block';
        anchor.style.scrollMarginTop = '110px';
        anchor.setAttribute('aria-hidden', 'true');
        target.before(anchor);
      }
    });
    const id = window.location.hash.slice(1);
    if (Object.hasOwn(anchors, id)) document.getElementById(id)?.scrollIntoView();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attachAnchors, {once:true});
  else attachAnchors();
  document.addEventListener('shopify:section:load', attachAnchors);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-media"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sa-media-gallery')) {
  customElements.define('sa-media-gallery',class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller=new AbortController();
      const signal=this.controller.signal;
      this.dialog=this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.querySelectorAll('[data-sa-lightbox]').forEach(link=>link.addEventListener('click',event=>{
        const source=link.querySelector('img');
        if (!source) return;
        event.preventDefault();
        const expanded=source.cloneNode(true);
        expanded.removeAttribute('srcset');
        expanded.removeAttribute('sizes');
        expanded.src=link.href;
        expanded.loading='eager';
        this.dialog.querySelector('.sa-media__expanded-image').replaceChildren(expanded);
        this.trigger=link;
        if (!this.dialog.open) this.dialog.showModal();
      },{signal}));
      this.querySelector('.sa-media__close').addEventListener('click',()=>this.dialog.close(),{signal});
      this.dialog.addEventListener('click',event=>{
        const box=this.dialog.getBoundingClientRect();
        if(event.target===this.dialog&&(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom))this.dialog.close();
      },{signal});
      this.dialog.addEventListener('close',()=>{
        this.dialog.querySelector('.sa-media__expanded-image').replaceChildren();
        if(this.trigger?.isConnected)this.trigger.focus({preventScroll:true});
      },{signal});
      this.querySelectorAll('video').forEach(video=>video.addEventListener('play',()=>{
        this.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();});
      },{signal}));
    }
    disconnectedCallback() { this.controller?.abort(); this.dialog?.close(); }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-pillow-finder-five"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sa-pillow-finder-five')) {
  customElements.define('sa-pillow-finder-five', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      if (document.readyState === 'loading') {
        this.ready = () => { if (this.isConnected) this.initialize(); };
        document.addEventListener('DOMContentLoaded', this.ready, { once: true });
      } else this.initialize();
    }
    initialize() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      this.questions = [...this.querySelectorAll('[data-question]')].filter(q => q.querySelector('input')).slice(0, 5);
      this.intro = this.querySelector('[data-intro]');
      this.journey = this.querySelector('[data-journey]');
      this.stage = this.querySelector('[data-stage]');
      this.shell = this.querySelector('.saf__shell');
      this.status = this.querySelector('[data-status]');
      this.index = -1;
      this.busy = false;
      const options = { signal: this.controller.signal };
      this.addEventListener('click', e => {
        if (e.target.closest('[data-start]')) this.move(0);
        if (e.target.closest('[data-back]')) this.move(this.index - 1);
        if (e.target.closest('[data-restart]')) this.restart();
      }, options);
      this.addEventListener('change', e => {
        if (!e.target.matches('input')) return;
        const q = e.target.closest('[data-question]');
        this.update(q);
        this.querySelector('[data-destination-error]').hidden = true;
      }, options);
      this.addEventListener('submit', e => {
        const q = e.target.closest('[data-question]');
        if (!q) return;
        e.preventDefault();
        if (this.busy || q !== this.questions[this.index]) return;
        if (this.selected(q).length === 0) {
          q.querySelector('[data-error]').hidden = false;
          this.status.textContent = this.dataset.required;
          return;
        }
        if (this.index === this.questions.length - 1) this.finish();
        else this.move(this.index + 1);
      }, options);
      document.addEventListener('shopify:block:select', e => {
        const i = this.questions.findIndex(q => q.dataset.blockId === e.detail?.blockId);
        if (i >= 0) this.move(i, true);
      }, options);
      this.questions.forEach((q, i) => {
        q.querySelector('[data-button-label]').textContent = i === this.questions.length - 1 ? this.dataset.finish : this.dataset.next;
        this.update(q);
      });
      this.querySelector('[data-start]').hidden = !this.questions.length;
      this.resetDisplay();
    }
    disconnectedCallback() {
      this.controller?.abort();
      document.removeEventListener('DOMContentLoaded', this.ready);
      this.cancelTransition();
      this.initialized = false;
    }
    selected(q) { return [...q.querySelectorAll('input')].filter(input => input.checked); }
    update(q) {
      q.querySelector('[data-continue]').disabled = this.selected(q).length === 0;
      q.querySelector('[data-error]').hidden = true;
    }
    reduced() { return this.dataset.animate === 'false' || window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    cancelTransition() { this.busy = false; }
    resetDisplay() {
      this.index = -1;
      this.intro.hidden = false;
      this.journey.hidden = true;
      this.querySelector('[data-restart]').hidden = true;
      this.questions.forEach(q => q.hidden = true);
      this.querySelector('[data-destination-error]').hidden = true;
    }
    restart() {
      this.cancelTransition();
      this.questions.forEach(q => {
        q.querySelectorAll('input').forEach(input => input.checked = false);
        q.querySelectorAll('textarea').forEach(input => input.value = '');
        q.querySelectorAll('details').forEach(d => d.open = false);
        this.update(q);
      });
      this.resetDisplay();
      this.querySelector('[data-start]').focus({ preventScroll: true });
    }
    move(next, immediate = false) {
      if (this.busy && !immediate) return;
      if (immediate) this.cancelTransition();
      if (next < 0) {
        this.cancelTransition();
        this.resetDisplay();
        this.querySelector('[data-start]').focus({ preventScroll: true });
        return;
      }
      if (!this.questions[next]) return;
      const previous = this.index;
      this.cancelTransition();
      this.intro.hidden = true;
      this.journey.hidden = false;
      this.querySelector('[data-restart]').hidden = false;
      this.querySelector('[data-destination-error]').hidden = true;
      this.index = next;
      this.questions.forEach((q, i) => {
        q.hidden = i !== next;
        q.classList.toggle('is-entering', i === next && !immediate && !this.reduced());
        q.dataset.entrance = String(Math.max(0, previous) % 4);
      });
      this.querySelector('[data-counter]').textContent = `${this.dataset.questionWord} ${next + 1} ${this.dataset.ofWord} ${this.questions.length}`;
      const heading = this.questions[next].querySelector('[data-heading]');
      heading.focus({ preventScroll: true });
      this.status.textContent = this.querySelector('[data-counter]').textContent + '. ' + heading.textContent;
      const rect = heading.getBoundingClientRect();
      if (rect.top < 0 || rect.top > window.innerHeight * .6) this.querySelector('[data-counter]').scrollIntoView({ behavior: this.reduced() ? 'instant' : 'smooth', block: 'start' });
    }
    finish() {
      const missing = this.questions.findIndex(q => this.selected(q).length === 0);
      if (missing >= 0) { this.move(missing, true); return; }
      let destination;
      try {
        if (!this.dataset.destination?.trim()) throw new Error();
        destination = new URL(this.dataset.destination, window.location.href);
        if (!['https:', 'http:'].includes(destination.protocol)) throw new Error();
      } catch {
        this.querySelector('[data-destination-error]').hidden = false;
        this.status.textContent = this.querySelector('[data-destination-error]').textContent;
        return;
      }
      window.location.assign(destination.href);
    }
  });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-positions"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sa-pillow-gallery')) {
  customElements.define('sa-pillow-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.tabs = [...this.querySelectorAll('[data-sa-tab]')];
      this.panels = [...this.querySelectorAll('[data-sa-panel]')];
      if (!this.tabs.length) return;
      this.querySelector('[data-sa-tabs]').hidden = false;
      this.setAttribute('data-sa-ready', '');
      this.panels.forEach((panel, i) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', this.tabs[i].id);
        panel.tabIndex = 0;
      });
      this.activate(this.tabs[0]);
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.activate(tab), {signal});
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = (i + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') target = (i - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.tabs.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          this.activate(this.tabs[target]);
          this.tabs[target].focus();
        }, {signal});
      });
      document.addEventListener('shopify:block:select', event => {
        const tab = this.tabs.find(item => item.dataset.saTab === event.detail?.blockId);
        if (tab) this.activate(tab);
      }, {signal});
    }
    activate(selected) {
      this.tabs.forEach(tab => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => {
        panel.hidden = panel.dataset.saPanel !== selected.dataset.saTab;
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-product-premium"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sa-premium-product')) {
  customElements.define('sa-premium-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-product-config]').textContent);
      this.querySelectorAll('[data-media-target]').forEach(button => button.addEventListener('click', () => this.showMedia(button.dataset.mediaTarget)));
      this.querySelectorAll('[data-option]').forEach(input => input.addEventListener('change', () => this.update(true)));
      this.update(false);
    }
    variant() {
      const options = [...this.querySelectorAll('[data-option]:checked')].sort((a,b) => Number(a.dataset.option) - Number(b.dataset.option)).map(input => input.value);
      if (!options.length) return this.config.variants.find(v => String(v.id) === this.dataset.initialVariant) || this.config.variants[0];
      return this.config.variants.find(v => v.options.length === options.length && v.options.every((value, index) => value === options[index]));
    }
    showMedia(id) {
      if (!this.querySelector('[data-media-panel="' + id + '"]')) return;
      this.querySelectorAll('[data-media-panel]').forEach(panel => {
        const hidden = panel.dataset.mediaPanel !== String(id);
        panel.hidden = hidden;
        if (hidden) panel.querySelectorAll('video').forEach(video => video.pause());
      });
      this.querySelectorAll('[data-media-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === String(id))));
    }
    update(notify) {
      const variant = this.variant(), s = this.config.strings;
      this.current = variant;
      this.querySelectorAll('[data-price]').forEach(node => { node.innerHTML = variant ? variant.formattedPrice : s.unavailable; });
      const hasCompare = variant && variant.compare_at_price > variant.price;
      this.querySelectorAll('[data-compare]').forEach(node => { node.hidden = !hasCompare; node.innerHTML = hasCompare ? variant.formattedCompare : ''; });
      this.querySelectorAll('[data-save]').forEach(node => { node.hidden = !hasCompare; node.innerHTML = hasCompare ? s.save + ' ' + variant.formattedSaving : ''; });
      this.querySelectorAll('[data-variant-id]').forEach(input => { input.value = variant?.id || ''; input.disabled = !variant; if (notify) input.dispatchEvent(new Event('change', {bubbles:true})); });
      this.querySelectorAll('[data-submit]').forEach(button => { button.disabled = !variant?.available; });
      this.querySelectorAll('[data-submit-label]').forEach(node => { node.textContent = !variant ? s.unavailable : variant.available ? s.cart : s.soldOut; });
      if (variant?.mediaId) this.showMedia(variant.mediaId);
      if (notify && variant) {
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
        this.dispatchEvent(new CustomEvent('variant:change', {bubbles:true,detail:{variant}}));
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
